/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "χθες",
        "-2": "προχθές",
        "0": "σήμερα",
        "1": "αύριο",
        "2": "μεθαύριο",
        "future": {
          "one": "σε {0} ημέρα",
          "other": "σε {0} ημέρες"
        },
        "past": {
          "one": "πριν από {0} ημέρα",
          "other": "πριν από {0} ημέρες"
        }
      },
      "day-narrow": {
        "-1": "χθες",
        "-2": "προχθές",
        "0": "σήμερα",
        "1": "αύριο",
        "2": "μεθαύριο",
        "future": {
          "one": "σε {0} ημ.",
          "other": "σε {0} ημ."
        },
        "past": {
          "one": "{0} ημ. πριν",
          "other": "{0} ημ. πριν"
        }
      },
      "day-short": {
        "-1": "χθες",
        "-2": "προχθές",
        "0": "σήμερα",
        "1": "αύριο",
        "2": "μεθαύριο",
        "future": {
          "one": "σε {0} ημ.",
          "other": "σε {0} ημ."
        },
        "past": {
          "one": "πριν από {0} ημ.",
          "other": "πριν από {0} ημ."
        }
      },
      "hour": {
        "0": "τρέχουσα ώρα",
        "future": {
          "one": "σε {0} ώρα",
          "other": "σε {0} ώρες"
        },
        "past": {
          "one": "πριν από {0} ώρα",
          "other": "πριν από {0} ώρες"
        }
      },
      "hour-narrow": {
        "0": "τρέχουσα ώρα",
        "future": {
          "one": "σε {0} ώ.",
          "other": "σε {0} ώ."
        },
        "past": {
          "one": "{0} ώ. πριν",
          "other": "{0} ώ. πριν"
        }
      },
      "hour-short": {
        "0": "τρέχουσα ώρα",
        "future": {
          "one": "σε {0} ώ.",
          "other": "σε {0} ώ."
        },
        "past": {
          "one": "πριν από {0} ώ.",
          "other": "πριν από {0} ώ."
        }
      },
      "minute": {
        "0": "τρέχον λεπτό",
        "future": {
          "one": "σε {0} λεπτό",
          "other": "σε {0} λεπτά"
        },
        "past": {
          "one": "πριν από {0} λεπτό",
          "other": "πριν από {0} λεπτά"
        }
      },
      "minute-narrow": {
        "0": "τρέχον λεπτό",
        "future": {
          "one": "σε {0} λ.",
          "other": "σε {0} λ."
        },
        "past": {
          "one": "{0} λ. πριν",
          "other": "{0} λ. πριν"
        }
      },
      "minute-short": {
        "0": "τρέχον λεπτό",
        "future": {
          "one": "σε {0} λεπ.",
          "other": "σε {0} λεπ."
        },
        "past": {
          "one": "πριν από {0} λεπ.",
          "other": "πριν από {0} λεπ."
        }
      },
      "month": {
        "-1": "προηγούμενος μήνας",
        "0": "τρέχων μήνας",
        "1": "επόμενος μήνας",
        "future": {
          "one": "σε {0} μήνα",
          "other": "σε {0} μήνες"
        },
        "past": {
          "one": "πριν από {0} μήνα",
          "other": "πριν από {0} μήνες"
        }
      },
      "month-narrow": {
        "-1": "προηγ. μήνας",
        "0": "τρέχ. μήνας",
        "1": "επόμ. μήνας",
        "future": {
          "one": "σε {0} μ.",
          "other": "σε {0} μ."
        },
        "past": {
          "one": "{0} μ. πριν",
          "other": "{0} μ. πριν"
        }
      },
      "month-short": {
        "-1": "προηγ. μήνας",
        "0": "τρέχων μήνας",
        "1": "επόμ. μήνας",
        "future": {
          "one": "σε {0} μήνα",
          "other": "σε {0} μήνες"
        },
        "past": {
          "one": "πριν από {0} μήνα",
          "other": "πριν από {0} μήνες"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "προηγούμενο τρίμηνο",
        "0": "τρέχον τρίμηνο",
        "1": "επόμενο τρίμηνο",
        "future": {
          "one": "σε {0} τρίμηνο",
          "other": "σε {0} τρίμηνα"
        },
        "past": {
          "one": "πριν από {0} τρίμηνο",
          "other": "πριν από {0} τρίμηνα"
        }
      },
      "quarter-narrow": {
        "-1": "προηγ. τρίμ.",
        "0": "τρέχον τρίμ.",
        "1": "επόμ. τρίμ.",
        "future": {
          "one": "σε {0} τρίμ.",
          "other": "σε {0} τρίμ."
        },
        "past": {
          "one": "{0} τρίμ. πριν",
          "other": "{0} τρίμ. πριν"
        }
      },
      "quarter-short": {
        "-1": "προηγ. τρίμ.",
        "0": "τρέχον τρίμ.",
        "1": "επόμ. τρίμ.",
        "future": {
          "one": "σε {0} τρίμ.",
          "other": "σε {0} τρίμ."
        },
        "past": {
          "one": "πριν από {0} τρίμ.",
          "other": "πριν από {0} τρίμ."
        }
      },
      "second": {
        "0": "τώρα",
        "future": {
          "one": "σε {0} δευτερόλεπτο",
          "other": "σε {0} δευτερόλεπτα"
        },
        "past": {
          "one": "πριν από {0} δευτερόλεπτο",
          "other": "πριν από {0} δευτερόλεπτα"
        }
      },
      "second-narrow": {
        "0": "τώρα",
        "future": {
          "one": "σε {0} δ.",
          "other": "σε {0} δ."
        },
        "past": {
          "one": "{0} δ. πριν",
          "other": "{0} δ. πριν"
        }
      },
      "second-short": {
        "0": "τώρα",
        "future": {
          "one": "σε {0} δευτ.",
          "other": "σε {0} δευτ."
        },
        "past": {
          "one": "πριν από {0} δευτ.",
          "other": "πριν από {0} δευτ."
        }
      },
      "week": {
        "-1": "προηγούμενη εβδομάδα",
        "0": "τρέχουσα εβδομάδα",
        "1": "επόμενη εβδομάδα",
        "future": {
          "one": "σε {0} εβδομάδα",
          "other": "σε {0} εβδομάδες"
        },
        "past": {
          "one": "πριν από {0} εβδομάδα",
          "other": "πριν από {0} εβδομάδες"
        }
      },
      "week-narrow": {
        "-1": "προηγ. εβδ.",
        "0": "τρέχ. εβδ.",
        "1": "επόμ. εβδ.",
        "future": {
          "one": "σε {0} εβδ.",
          "other": "σε {0} εβδ."
        },
        "past": {
          "one": "{0} εβδ. πριν",
          "other": "{0} εβδ. πριν"
        }
      },
      "week-short": {
        "-1": "προηγ. εβδομάδα",
        "0": "τρέχ. εβδομάδα",
        "1": "επόμ. εβδομάδα",
        "future": {
          "one": "σε {0} εβδ.",
          "other": "σε {0} εβδ."
        },
        "past": {
          "one": "πριν από {0} εβδ.",
          "other": "πριν από {0} εβδ."
        }
      },
      "year": {
        "-1": "πέρσι",
        "0": "φέτος",
        "1": "επόμενο έτος",
        "future": {
          "one": "σε {0} έτος",
          "other": "σε {0} έτη"
        },
        "past": {
          "one": "πριν από {0} έτος",
          "other": "πριν από {0} έτη"
        }
      },
      "year-narrow": {
        "-1": "πέρσι",
        "0": "φέτος",
        "1": "επόμενο έτος",
        "future": {
          "one": "σε {0} έτος",
          "other": "σε {0} έτη"
        },
        "past": {
          "one": "{0} έτος πριν",
          "other": "{0} έτη πριν"
        }
      },
      "year-short": {
        "-1": "πέρσι",
        "0": "φέτος",
        "1": "επόμενο έτος",
        "future": {
          "one": "σε {0} έτος",
          "other": "σε {0} έτη"
        },
        "past": {
          "one": "πριν από {0} έτος",
          "other": "πριν από {0} έτη"
        }
      }
    },
    "locale": "el"
  });
}